import React, { useState} from "react";
import Table from "@mui/material/Table";
import { Edit } from "@mui/icons-material";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableContainer from "@mui/material/TableContainer";
import LinearProgress from "@mui/material/LinearProgress";
import TablePagination from "@mui/material/TablePagination";
import { SIZES, SORT_ORDERS, ALIGN, HTML_TAGS } from "../../common/constants/commonConstants.js";
import { SCHEDULE_MESSAGES, SCHEDULE_TABLE_COLUMN_KEYS } from "../../common/constants/scheduleModule/scheduleConstants.js";
import { useClientTimeZone, formatDateInZone, zoneAbbr } from "../../utils/clienttimezone";
import UpcomingScheduleMessages from "./UpcomingScheduleMessages.jsx";

const UpcomingSchedulesTable = ({
	page,
	order,
	setPage,
	orderBy,
	rowsPerPage,
	setShowSearch,
	schedules,
	setRowsPerPage,
	columns,
	handleRequestSort,
	isSchedulesLoading,
	filteredSchedulesLength,
}) => {
	const [selectedScheduleID, setSelectedScheduleID] = useState("");
    const [selectedCampaignName, setSelectedCampaignName] = useState("");
    const [selectedScheduleName, setSelectedScheduleName] = useState("");
    const [selectedScheduleDataId, setSelectedScheduleDataId] = useState("");

	// Scheduled times render in the configured client zone, not the browser's.
	// The hook reads a module-level cache, so mounting it here costs no extra
	// request even though the parent doesn't pass it down.
	const { timeZone } = useClientTimeZone();
	const tzLabel = zoneAbbr(timeZone);

	const handleScheduleEdit = (scheduleID, scheduleDataId, campaignName, scheduleName) => {
		setSelectedScheduleID(scheduleID);
        setSelectedScheduleDataId(scheduleDataId);
        setSelectedCampaignName(campaignName);
        setSelectedScheduleName(scheduleName);
		setShowSearch(false);
	};

	const handleScheduleBack = () => {
		setSelectedScheduleID("");
        setSelectedScheduleDataId("");
        setSelectedCampaignName("");
        setSelectedScheduleName("");
		setShowSearch(true);
	};

	return (
		<>
			{selectedScheduleID ? (
				<UpcomingScheduleMessages
					scheduleID={selectedScheduleID}
                    scheduleDataId={selectedScheduleDataId}
                    campaignName={selectedCampaignName}
                    scheduleName={selectedScheduleName}
					onBack={() => handleScheduleBack()}
				/>
			) : (
			<TableContainer sx={{ mt: 2 }}>
                <Table size={SIZES.SMALL}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    sortDirection={orderBy === column.id ? order : false}
                                    sx={{
                                        width:
                                            column.id === SCHEDULE_TABLE_COLUMN_KEYS.ACTIONS ? 50 :
											column.id === SCHEDULE_TABLE_COLUMN_KEYS.SCHEDULED_AT ? 200 :
											column.id === SCHEDULE_TABLE_COLUMN_KEYS.CAMPAIGN_NAME ? 250 :
                                            column.id === SCHEDULE_TABLE_COLUMN_KEYS.MESSAGE_COUNT ? 150 :
											column.id === SCHEDULE_TABLE_COLUMN_KEYS.SCHEDULE_NAME ? 250 :
											column.id === SCHEDULE_TABLE_COLUMN_KEYS.CHANNEL ? 250 : 200,
                                    }}
                                >
                                    {column.isSortable ? (
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? order : SORT_ORDERS.ASCENDING}
                                            onClick={() =>
                                                handleRequestSort(column.id)
                                            }
                                        >
                                            {column.id === SCHEDULE_TABLE_COLUMN_KEYS.SCHEDULED_AT
                                                ? `${column.label} (${tzLabel})`
                                                : column.label}
                                        </TableSortLabel>
                                    ) : column.id === SCHEDULE_TABLE_COLUMN_KEYS.SCHEDULED_AT
                                        ? `${column.label} (${tzLabel})`
                                        : column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isSchedulesLoading ? (
                            <TableRow>
                                <TableCell colSpan={columns.length} align={ALIGN.CENTER} >
                                    <LinearProgress />
                                </TableCell>
                            </TableRow>
                        ) : schedules.length > 0 ? schedules.map((schedule) => (
                            <TableRow hover tabIndex={-1} key={schedule.id}>
								<TableCell>
									<IconButton 
										onClick={() => handleScheduleEdit(
                                            schedule.CampaignScheduleID,
                                            schedule.Id,
                                            schedule.campaignname,
                                            schedule.CampaignScheduleName)
                                        }
									>
										<Edit fontSize={SIZES.SMALL} />
									</IconButton>
								</TableCell>
                                <TableCell>
									{formatDateInZone(schedule.scheduled_at, timeZone)}
                                </TableCell>
                                <TableCell>
                                    {schedule.campaignname}
                                </TableCell>
                                <TableCell>
                                    {schedule.messageCount}
                                </TableCell>
                                <TableCell>
                                    {schedule.CampaignScheduleName}
                                </TableCell>
                                <TableCell>
                                    {schedule.channeltypename}
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={columns.length} align={ALIGN.CENTER}>
                                    {SCHEDULE_MESSAGES.NO_SCHEDULES}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    component={HTML_TAGS.DIV}
                    count={filteredSchedulesLength}
                    rowsPerPageOptions={[10, 25, 50]}
                    onPageChange={(event, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(event) => {
                        setPage(0);
                        setRowsPerPage(parseInt(event.target.value, 10));
                    }}
                />
            </TableContainer>
			)}
        </>
	);
};

export default UpcomingSchedulesTable;